import { FieldSet, FormContext, FormState, FormValues, TextInput, TextInputTypes, uniqueGUID } from "o4a-react";
import * as React from "react";
import * as Messages from "../../codegen/Messages";
import { defaultAdbsUsername } from "../../helpers/resourceHelper";
import { validateAdbPassword } from "../../helpers/validationHelper";

export const GROUP_SECURITY = "security";

export const enum Fields {
  username = "username",
  password = "adbsDatabaseDetails.adminPassword",
  passwordConfirm = "passwordConfirm",
}

export enum FieldTestIds {
  PasswordInput = "password-input",
  PasswordConfirmInput = "password-confirm-input",
}

export const SecurityTabContent = (): JSX.Element => {
  const [passwordVal, setPasswordVal] = React.useState<string>();
  const form: FormState = React.useContext(FormContext);
  const [confirmPassWordKey, setConfirmPasswordKey] = React.useState<string>(uniqueGUID());

  const onChangePassword = (value: string): void => {
    setPasswordVal(value);
    const formValues: FormValues = form.getGroupValues(GROUP_SECURITY);
    if (formValues[Fields.passwordConfirm] !== undefined) {
      form.setValue(undefined, Fields.passwordConfirm, GROUP_SECURITY);
      setConfirmPasswordKey(uniqueGUID());
    }
  };

  return (
    <FieldSet header={Messages.createAdbs.securityTab.sectionTitles.databaseAdministratorCredentials()}>
      <TextInput
        fieldName={Fields.username}
        label={Messages.labels.username()}
        defaultValue={defaultAdbsUsername}
        disabled
      />
      <TextInput
        fieldName={Fields.password}
        label={Messages.labels.password()}
        testId={FieldTestIds.PasswordInput}
        tooltip={Messages.hints.tooltipPasswordAdb()}
        textType={TextInputTypes.PASSWORD}
        required
        onChange={value => { onChangePassword(value); }}
        validator={validateAdbPassword}
      />

      <TextInput
        key={confirmPassWordKey}
        fieldName={Fields.passwordConfirm}
        label={Messages.labels.passwordConfirm()}
        testId={FieldTestIds.PasswordConfirmInput}
        textType={TextInputTypes.PASSWORD}
        required
        validator={(value: string) => {
          if (value && (value !== passwordVal)) {
            return [Messages.validation.passwordConfirmation()];
          }
          return undefined;
        }}
      />
    </FieldSet>
  );
};
